import type { IconSvgObject } from './types';

const GitlabIcon: IconSvgObject = [
  ["path", { d: "M5.5 2.02344L9 10.0234H15L18.5 2.02344L22 14.0234L12 22.0234L2 14.0234L5.5 2.02344Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default GitlabIcon;
